module.exports = __webpack_public_path__ + "img/1_006.4e897a9a.jpg";